export let agentJobsAutomationsHeader = "oqE$ub";
export let agentJobsWorkflowsHeader = "m3qxie";
export default {agentJobsAutomationsHeader,agentJobsWorkflowsHeader};